<template>
  <!--Emitido ao abrir e fechar o modal
      @event change
      @property {Boolean} opened - Valor atual do modal -->
  <v-dialog
    ref="dialog"
    class="zoox-component zoox-modal"
    v-bind="$attrs"
    :content-class="'zoox-card-modal ' + contentClass"
    :width="width"
    :value="opened"
    :persistent="persistent"
    :fullscreen="fullscreen"
    @keydown.esc="onKeydown"
    @click:outside="onClickOutside"
    @change="$emit('change', $event)"
  >
    <z-card data-app :width="width" :height="height" :title="title">
      <template #title>
        <!--@slot Slot de título do card -->
        <slot name="title"></slot>
      </template>

      <template v-if="closable" #actions>
        <!--@slot Slot de ações do card -->
        <slot name="actions"></slot>
        <z-icon
          v-if="closable"
          ref="close-btn"
          class="zoox-close-modal"
          @click="onClickClose"
          >$close_rounded</z-icon
        >
      </template>
      <template #content>
        <!--@slot Slot de conteúdo do card -->
        <slot name="content"></slot>
      </template>
    </z-card>
  </v-dialog>
</template>

<script>
import zCard from '../Card/Card.vue'
import zIcon from '../../atoms/Icon/Icon.vue'

/**
 * @displayName Card Modal
 */
export default {
  name: 'ZCardModal',
  components: {zCard, zIcon},
  model: {
    prop: 'opened',
    event: 'change',
  },
  props: {
    /**
     * Flag para indicar que está aberta (model)
     *
     * @modelName opened
     */
    opened: {
      type: Boolean,
      required: true,
      default: false,
    },
    /**
     * Flag para indicar que é fullscreen
     */
    fullscreen: {
      type: Boolean,
      default: false,
    },
    /**
     * Título do card
     */
    title: {
      type: String,
      required: false,
      default: '',
    },
    /**
     * Largura do card
     */
    width: {
      type: [String, Number],
      required: false,
      default: 600,
    },
    /**
     * Altura do card
     */
    height: {
      type: [String, Number],
      required: false,
      default: 'auto',
    },

    /**
     * Flag para indicar que é fechável
     */
    closable: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para indicar que é persistente
     */
    persistent: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Classe CSS para customização do conteúdo da modal
     */
    contentClass: {
      type: String,
      required: false,
      default: '',
    },
  },

  methods: {
    onClickClose() {
      this.$emit('change', false)
    },
    onClickOutside() {
      this.persistent ? this.$emit('change', true) : this.$emit('change', false)
    },
    onKeydown() {
      if (!this.persistent) {
        this.$emit('change', false)
      } else {
        this.$emit('change', true)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.zoox-card-modal {
  border-radius: var(--component-card-radius) !important;

  > * {
    border-radius: var(--component-card-radius) !important;
  }
}
</style>
